import type { ContenidoUbicacion, ArticuloUbi } from "./ModalEditarUbicacion";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { useMemo } from "react";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { formatContenedor, formatIDArt } from "@/ts/util";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaArticulo(props: { readonly data: ContenidoUbicacion; }) {
	const { columns, features } = useMemo(() => Columns(), []);


	const data = useMemo(() => {
		const articulos: ArticuloUbi[] = [...props.data.articulos];
		for (const contenedor of props.data.contenedores) {
			articulos.push(...contenedor.articulos);
		}

		return articulos;
	}, [props.data]);

	return (
		<TypedTable
			className="dataTable display"
			data={data}
			columns={columns}
			features={features}

			pagination
			globalSearch

			noResultsMessage="No hay artículos en la ubicación"
			errorMessage="Error cargando los subpuestos"
			isLoading={false}
			isError={false}
		/>
	);
}


function Columns() {
	const columnHelper = createColumnHelper<typeof features, ArticuloUbi>();
	const features = tableFeatures(CommonFeatures);

	const contenedorAccessor = (info: ArticuloUbi) => formatContenedor(info.contenedor);
	const articuloFaseAccesor = (info: ArticuloUbi) => formatIDArt(info.id, info.idFase);

	const columns = columnHelper.columns([
		columnHelper.accessor(articuloFaseAccesor, { header: "Artículo", meta: { className: "dt-center" } }),
		columnHelper.accessor("descripcion", { header: "Descripción", meta: { className: "dt-center" } }),
		columnHelper.accessor(contenedorAccessor, { header: "Contenedor", meta: { className: "dt-center" }, }),
		columnHelper.accessor("cantidad", { header: "Cantidad", meta: { className: "dt-center" }, }),
	]);
	return { columns, features };
}